import React, { useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';

type SelectedPlaceProps = {
  text: string | React.ReactChild;
  lat: number | null;
  lng: number | null;
  className?: string;
};

export const SelectedPlace = ({ text, className, ...props }: SelectedPlaceProps) => (
  <div className={className}>{text}</div>
);

type Props = {
  center: {
    lat: string;
    lng: string;
  };
  zoom?: number;
  className?: string;
  children: React.ReactChild | React.ReactChild[];
  pathCoordinates?: { lat: number; lng: number }[];
};

const GoogleMap = ({ zoom, className, center, children, pathCoordinates = [] }: Props) => {
  const [map, setMap] = useState<google.maps.Map | null>(null);

  const handleApiLoaded = (map: google.maps.Map, maps: typeof google.maps) => {
    setMap(map);
    if (pathCoordinates && pathCoordinates.length > 1) {
      drawStyledPolyline(map, pathCoordinates);
    }
  };

  const drawStyledPolyline = (map: google.maps.Map, path: { lat: number; lng: number }[]) => {
    if (path.length > 1) {
      const curvePath = createCurvePath(path);
      const polyline = new google.maps.Polyline({
        path: curvePath,
        strokeColor: '#FF0000',
        strokeOpacity: 1.0,
        strokeWeight: 2,
        icons: [
          {
            icon: {
              path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
            },
            offset: '100%',
          },
        ],
      });
      polyline.setMap(map);
    }
  };

  const createCurvePath = (path: { lat: number; lng: number }[]) => {
    if (path.length < 2) return path;

    const start = path[0];
    const end = path[path.length - 1];
    const midpoint = {
      lat: (start.lat + end.lat) / 2,
      lng: (start.lng + end.lng) / 2,
    };

    const controlPoint = {
      lat: midpoint.lat + (Math.abs(start.lng - end.lng) / 3),
      lng: midpoint.lng + (Math.abs(start.lat - end.lat) / 3),
    };

    const curvePath = [];
    const steps = 100;
    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      const lat = (1 - t) ** 2 * start.lat + 2 * (1 - t) * t * controlPoint.lat + t ** 2 * end.lat;
      const lng = (1 - t) ** 2 * start.lng + 2 * (1 - t) * t * controlPoint.lng + t ** 2 * end.lng;
      curvePath.push({ lat, lng });
    }

    return curvePath;
  };

  useEffect(() => {
    if (map && pathCoordinates && pathCoordinates.length > 1) {
      drawStyledPolyline(map, pathCoordinates);
    }
  }, [map, pathCoordinates]);

  return (
    <div className={className}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyAvxXRWQhSheFlKpF4Mona548c_madhD0w' }}
        defaultCenter={{
          lat: +center.lat,
          lng: +center.lng,
        }}
        defaultZoom={zoom}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
      >
        {children}
      </GoogleMapReact>
    </div>
  );
};

GoogleMap.defaultProps = {
  center: {
    lat: '0',
    lng: '0',
  },
  zoom: 12,
  text: 'HERE',
  pathCoordinates: [], 
};

export default GoogleMap;
